// Call the checkCookie function when the page loads
window.addEventListener('load', checkCookie);

// Add event listener for the grow-zone-finder
document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('GrowZoneLookupForm');
    const input = document.getElementById('GrowZoneZipCodeInput');
    
    form.addEventListener('submit', function(event) {
        event.preventDefault(); // Prevent default form submission
      
        const zipCode = input.value;
        const endpoint = getSetting("endpoint");
      
        // Make API call
        fetch(endpoint + '/' + zipCode, {
            method: 'GET', 
            headers: {'Content-Type': 'application/json'}
        })
        .then(response => response.json())
        .then(data => {
            if(data.number){
              // Store the returned number in a cookie
              createCookie(getSetting("zone_cookie_identifier"), data.number, 365);
              createCookie(getSetting("zip_cookie_identifier"), zipCode, 365);
              
              document.querySelector("#ZoneNumber").innerHTML = data.number;
              document.querySelector("#ZipCode").innerHTML = zipCode;  
              hide(document.getElementById("SetZoneContainer"));
              show(document.getElementById("ZoneDetailsContainer"));
              document.querySelector("#LocationMarker").innerHTML ='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,2C15.31,2 18,4.66 18,7.95C18,12.41 12,19 12,19C12,19 6,12.41 6,7.95C6,4.66 8.69,2 12,2M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M20,19C20,21.21 16.42,23 12,23C7.58,23 4,21.21 4,19C4,17.71 5.22,16.56 7.11,15.83L7.75,16.74C6.67,17.19 6,17.81 6,18.5C6,19.88 8.69,21 12,21C15.31,21 18,19.88 18,18.5C18,17.81 17.33,17.19 16.25,16.74L16.89,15.83C18.78,16.56 20,17.71 20,19Z" /></svg>';       
              toggleGrowZoneDrawer();
            }
            else{
                eraseCookie(getSetting("zone_cookie_identifier"));
                eraseCookie(getSetting("zip_cookie_identifier"));
              
                show(document.getElementById("GrowZoneFinderError"));
                show(document.getElementById("SetZoneContainer"));
                hide(document.getElementById("ZoneDetailsContainer"));
            }            
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });
});

// Function to check if the cookie exists
function checkCookie() {
    const cookieValue = getCookie(getSetting("zone_cookie_identifier")); 
    const zipCodeCookieValue = getCookie(getSetting("zip_cookie_identifier"));

    if (cookieValue) {
        // Hide form, show selected zone
        document.querySelector("#ZoneNumber").innerHTML = cookieValue;
        document.querySelector("#ZipCode").innerHTML = zipCodeCookieValue;
          document.querySelector("#LocationMarker").innerHTML ='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,2C15.31,2 18,4.66 18,7.95C18,12.41 12,19 12,19C12,19 6,12.41 6,7.95C6,4.66 8.69,2 12,2M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M20,19C20,21.21 16.42,23 12,23C7.58,23 4,21.21 4,19C4,17.71 5.22,16.56 7.11,15.83L7.75,16.74C6.67,17.19 6,17.81 6,18.5C6,19.88 8.69,21 12,21C15.31,21 18,19.88 18,18.5C18,17.81 17.33,17.19 16.25,16.74L16.89,15.83C18.78,16.56 20,17.71 20,19Z" /></svg>';       
        hide(document.getElementById("SetZoneContainer"));
        show(document.getElementById("ZoneDetailsContainer"));
    } else {
        // show the zone finder form
        show(document.getElementById("SetZoneContainer"));
        document.querySelector("#LocationMarker").innerHTML ='<svg class="nhn-cta-yellow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7A2,2 0 0,0 10,9H8A4,4 0 0,1 12,5A4,4 0 0,1 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z" /></svg>';
        toggleClass(document.querySelector("#LocationMarker"), 'location-marker-animate');
        hide(document.getElementById("ZoneDetailsContainer"));
    }
}

// Function to toggle the visibility of the grow zone lookup drawer
function toggleGrowZoneDrawer() {
    toggleClass(document.getElementById('FindGrowZoneDrawer'), 'open');
};

// Generic function to toggle a class for an element
function toggleClass(element, className){
  if (!element || !className){ return; }
  
  var classString = element.className, nameIndex = classString.indexOf(className);
  if (nameIndex == -1) { classString += ' ' + className; }
  else {classString = classString.substr(0, nameIndex) + classString.substr(nameIndex+className.length);}
  element.className = classString;
}

// Show an element
function show (elem) {
	elem.style.display = 'block';
};

// Hide an element
function hide (elem) {
	elem.style.display = 'none';
};

// Function to create a cookie
function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

// Functiont to erase a cookie value by name
function eraseCookie(name) {
    createCookie(name, "", -1);
}

// Function to retrieve cookie value by name
function getCookie(cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for(let i = 0; i <cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return null;
}

// Define a function to retrieve the setting
function getSetting(settingId) {
    if (window.zoneThemeSettings && settingId in window.zoneThemeSettings) {
        return window.zoneThemeSettings[settingId];
    } else {
        return null; // Return null if the property doesn't exist
    }
}
